import { useVerificacaoDialog } from "./use-verificacao-dialog";
import { VerificacaoDialogView } from "./view-verificacao-dialog";
import type { VerificacaoDialogProps } from "./types-verificacao-dialog";

export function VerificacaoDialog(props: VerificacaoDialogProps) {
  const vm = useVerificacaoDialog(props);

  return <VerificacaoDialogView {...props} {...vm} />;
}

export type * from "./types-verificacao-dialog";
